import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LPadrao from "@/layouts/LPadrao/LPadrao.vue"
  import { ref } from "vue"
  import { MenuItem } from "primevue/menuitem"
  import { TTipoDeAtividades } from "@/components/Atividades"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TipoDeAtividades',
  setup(__props) {

  const home = ref<MenuItem>({
    label: "tipos de atividade",
    icon: "pi pi-calendar",
    to: "/atividades",
  })

  const breadCrumbItems = ref<MenuItem[]>([])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LPadrao, { class: "Atividades" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TTipoDeAtividades), {
        "bread-crumb-items": breadCrumbItems.value,
        home: home.value
      }, null, 8, ["bread-crumb-items", "home"])
    ]),
    _: 1
  }))
}
}

})